export const retrieveChoices = '/retrieveChoices';

export const addProducts = '/addProducts';

export const calculate = '/calculate';
